import styled from "styled-components"

const StyledCalendar = styled.div`
  & .rbc-event {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    padding: 0 0.25rem;
    font-size: 0.85rem;
  }
  & .rbc-today {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    opacity: 0.2;
  }
  & .rbc-show-more {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
    text-decoration: none;
  }
`

const CalendarButton = styled.button`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  &:hover {
    background: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const CalendarButtonSelected = styled.button`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  background: ${(props) => props.theme.b_color_gradients.b_dark};
`

const StyledEvent = styled.span`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const EventDetailsCancel = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export {
  StyledCalendar,
  CalendarButton,
  CalendarButtonSelected,
  StyledEvent,
  EventDetailsCancel,
}
